export enum ProviderSharingErrorCode {
  STRIPE_ACCOUNT_NOT_PAYABLE = 'STRIPE_ACCOUNT_NOT_PAYABLE',
}

export enum PromotedListingStatus {
  NEEDS_APPROVAL = 'needs-approval',
  NEEDS_PROVIDER_APPROVAL = 'needs-provider-approval',
  NEEDS_PROMOTER_APPROVAL = 'needs-promoter-approval',
  PROMOTER_REQUESTED = 'promoter-requested',
  APPROVED = 'approved',
  DECLINED = 'declined',
  ENDED = 'ended',
}

export enum PromoterAgreementStatus {
  APPROVED = 'approved',
  DECLINED = 'declined',
  ENDED = 'ended',
  NEEDS_APPROVAL = 'needs-approval',
  NEEDS_ORGANIZATION_APPROVAL = 'needs-organization-approval',
  NEEDS_PROMOTER_APPROVAL = 'needs-promoter-approval',
  NEEDS_PROVIDER_APPROVAL = 'needs-provider-approval',
  PROMOTER_REQUESTED = 'promoter-requested',
  REVOKED = 'revoked',
}

// Statuses that mean the partnership is no longer active and a fresh request is allowed.
export const TERMINAL_PROMOTER_AGREEMENT_STATUSES: readonly PromoterAgreementStatus[] = [
  PromoterAgreementStatus.DECLINED,
  PromoterAgreementStatus.REVOKED,
  PromoterAgreementStatus.ENDED,
];

export enum PromoterCommissionType {
  PERCENTAGE = 'percentage',
  FLAT = 'flat',
}

/**
 * Grants a provider can give a promoter on a promoter_agreement. `EDIT` is the umbrella grant:
 * any future granular grant (e.g. edit_sessions, edit_price) only matters when `EDIT` is absent.
 * "Publish only" is expressed by omitting `EDIT`, not by a dedicated value.
 */
export enum PromoterPermissionGrant {
  PUBLISH = 'publish',
  EDIT = 'edit',
}

/**
 * Controls how a promoter (partner) can publish a provider's experience.
 * Set by the provider on the experience editor's "Partners" tab.
 */
export enum RequestToPublish {
  /** Promoter must request the listing; the provider approves before it publishes. */
  REQUEST_TO_PUBLISH = 'request-to-publish',
  /** Promoter can instantly publish the listing; no provider approval needed. */
  INSTANT_PUBLISH = 'instant-publish',
}
